(function () {
  'use strict';

  /* ---------- Polyfills ---------- */
  if (!window.CSS) window.CSS = {};
  if (!CSS.escape) {
    CSS.escape = function (sel) {
      return String(sel).replace(/("|'|\\|#|\.|\[|\]|\(|\)|:|\?|\*|\+|\^|\$|!|~|=|>|<|{|}|,)/g, '\\$1');
    };
  }

  /* ---------- Constants ---------- */
  var MAIN_SEL = 'main#MainContent, main[id="MainContent"], [data-main-content]';
  var DEBOUNCE_DELAY = 200;
  var REQUEST_TIMEOUT = 8000;
  var REQUEST_CACHE_SIZE = 5;

  /* ---------- Simple LRU Cache ---------- */
  var cache = Object.create(null);
  var order = [];

  function cacheSet(key, value) {
    if (cache[key]) return;
    cache[key] = value;
    order.push(key);
    if (order.length > REQUEST_CACHE_SIZE) {
      var old = order.shift();
      delete cache[old];
    }
  }
  function cacheGet(key) { return cache[key] || null; }

  /* ---------- Utilities ---------- */
  function getMain() { return document.querySelector(MAIN_SEL); }

  function centerChip(root, container, handle, smooth) {
    if (!handle || !container) return;
    var chip = root.querySelector('[data-chip][data-col-handle="' + CSS.escape(handle) + '"]');
    if (!chip) return;

    var cRect = container.getBoundingClientRect();
    var pRect = chip.getBoundingClientRect();
    var delta = (pRect.left + pRect.width / 2) - (cRect.left + cRect.width / 2);

    var maxScroll = container.scrollWidth - container.clientWidth;
    var target = Math.max(0, Math.min(container.scrollLeft + delta, maxScroll));
    container.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
  }

  function rerunInlineScripts(scopeEl) {
    var scripts = scopeEl.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      if (old.src || old.type === 'module') continue;
      var s = document.createElement('script');
      if (old.type) s.type = old.type;
      if (old.noModule) s.noModule = true;
      if (old.defer) s.defer = true;
      if (old.async) s.async = true;
      if (old.textContent) s.textContent = '(function(){try{' + old.textContent + '}catch(e){console.error("Script error:", e);}})();';
      for (var j = 0; j < old.attributes.length; j++) {
        var a = old.attributes[j];
        if (a.name !== 'type' && a.name !== 'nomodule' && a.name !== 'defer' && a.name !== 'async') {
          s.setAttribute(a.name, a.value);
        }
      }
      old.parentNode.replaceChild(s, old);
    }
  }

  function fetchWithCache(url) {
    var cached = cacheGet(url);
    if (cached) return Promise.resolve(cached);

    var hasAbort = typeof AbortController !== 'undefined';
    var controller = hasAbort ? new AbortController() : null;
    var signal = hasAbort ? controller.signal : undefined;
    var timer = setTimeout(function () { if (hasAbort) controller.abort(); }, REQUEST_TIMEOUT);

    return fetch(url, { credentials: 'same-origin', signal: signal })
      .then(function (res) {
        clearTimeout(timer);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) { cacheSet(url, html); return html; })
      .catch(function (err) { clearTimeout(timer); throw err; });
  }

  function initSection(root) {
    if (!root || root.dataset.faithLoaded === 'true') return;

    var chipsWrap = root.querySelector('[data-faith-chips]');
    if (!chipsWrap) return;

    var inFlight = false;
    var debounceTimer = null;

    function setActiveChip(handle) {
      var chips = root.querySelectorAll('[data-chip]');
      for (var i = 0; i < chips.length; i++) {
        var chip = chips[i];
        var on = !!handle && (chip.dataset.colHandle || '') === handle;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    function fetchAndReplace(handle, replaceHistory) {
      if (inFlight) return;
      inFlight = true;

      var main = getMain();
      var url = '/collections/' + encodeURIComponent(handle);
      if (!main) { window.location.href = url; return; }

      main.classList.add('is-loading');
      fetchWithCache(url)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newMain = doc.querySelector(MAIN_SEL);
          if (!newMain) throw new Error('Main content not found');

          main.innerHTML = newMain.innerHTML;
          rerunInlineScripts(main);

          if (replaceHistory !== false) history.pushState({ handle: handle }, '', url);

          setActiveChip(handle);
          requestAnimationFrame(function () {
            centerChip(root, chipsWrap, handle, true);

            document.dispatchEvent(new CustomEvent('faith:collection:changed', {
              detail: { handle: handle, container: main }
            }));

            try { window.SPR && SPR.initDomEls && SPR.loadBadges(); } catch (e) {}
            try { window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(); } catch (e) {}
            try { window.ProductModel && window.ProductModel.loadShopifyXR && window.ProductModel.loadShopifyXR(); } catch (e) {}

            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          });
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          var m = getMain(); if (m) m.classList.remove('is-loading');
          inFlight = false;
        });
    }

    // 保存给全局 popstate 使用
    root.__faithFetchAndReplace = fetchAndReplace;

    // 防抖函数（单实例）
    function debounce(fn, delay) {
      return function () {
        var args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { fn.apply(null, args); }, delay);
      };
    }
    var debouncedFetch = debounce(function (handle, replaceHistory) {
      fetchAndReplace(handle, replaceHistory);
    }, DEBOUNCE_DELAY);

    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (!chip) return;

      var handle = chip.dataset.colHandle;
      var isActive = chip.classList.contains('is-active');

      if (!handle || isActive || inFlight) return;
      e.preventDefault();

      setActiveChip(handle);
      centerChip(root, chipsWrap, handle, true);

      debouncedFetch(handle, true);
    });

    // 首屏：补历史状态 & 居中
    (function () {
      var active = root.querySelector('[data-chip].is-active');
      if (active && active.dataset.colHandle) {
        if (!history.state) history.replaceState({ handle: active.dataset.colHandle }, '', window.location.pathname);
        centerChip(root, chipsWrap, active.dataset.colHandle, false);
        requestAnimationFrame(function () { centerChip(root, chipsWrap, active.dataset.colHandle, false); });
      }
    })();

    root.dataset.faithLoaded = 'true';
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-faith-section]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor 动态加载
  document.addEventListener('shopify:section:load', function (e) {
    var el = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
    if (el && el.matches('[data-faith-section]')) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
    if (el) el.dataset.faithLoaded = 'false';
  });

  // 全局 popstate（只绑定一次）
  if (!window.__faithPopstateBound) {
    window.addEventListener('popstate', function (e) {
      var state = e.state || {};
      if (!state.handle) return;

      var sections = document.querySelectorAll('[data-faith-section][data-faith-loaded="true"]');
      sections.forEach(function (root) {
        if (typeof root.__faithFetchAndReplace === 'function') {
          root.__faithFetchAndReplace(state.handle, false);
        }
      });
    }, { passive: true });
    window.__faithPopstateBound = true;
  }
})();
